module.exports = __webpack_public_path__ + "static/media/4.990a7dc3.jpg";